import { lazy, Suspense } from 'react'
import DashboardLayout from '../layouts/Dashboard'
import AuthGuard from '../components/guards/AuthGuard'
import { ConfluencePages, UserRole } from '../enums'
import { UserManualProvider } from '../contexts/userManual'
import Redirect from '../pages/Redirect'
import LoadingState from '../components/LoadingState'

const Projects = lazy(() => import('../pages/pages/Projects'))
const Project = lazy(() => import('../pages/pages/Project'))
const EditProject = lazy(() => import('../pages/pages/EditProject'))
const ProjectStats = lazy(() => import('../pages/pages/ProjectStats'))
const InviteUser = lazy(() => import('../pages/pages/inviteUser'))
const ProjectJoin = lazy(() => import('../pages/pages/ProjectJoin'))

export default [
  {
    path: '/projects',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.MANUFACTURER,
          UserRole.INSTALLER,
          UserRole.GUEST
        ]}
      >
        <UserManualProvider pageId={ConfluencePages.PROJECTS}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <Projects />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/projects/join/:token',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.MANUFACTURER,
          UserRole.INSTALLER,
          UserRole.GUEST
        ]}
      >
        <UserManualProvider pageId={ConfluencePages.PROJECTS}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <ProjectJoin />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/projects/:id',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.MANUFACTURER,
          UserRole.INSTALLER,
          UserRole.GUEST
        ]}
      >
        <UserManualProvider pageId={ConfluencePages.PROJECTS}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <Project />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/projects/:id/edit',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.INSTALLER,
          UserRole.GUEST
        ]}
      >
        <UserManualProvider pageId={ConfluencePages.PROJECTS}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <EditProject />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/projects/:id/stats',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN, UserRole.ADMIN, UserRole.USER]}>
        <UserManualProvider pageId={ConfluencePages.PROJECTS}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <ProjectStats />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/projects/:id/invite-user',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN, UserRole.ADMIN, UserRole.USER, UserRole.INSTALLER]}>
        <UserManualProvider pageId={ConfluencePages.PROJECTS}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <InviteUser />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/project',
    children: [
      {
        path: ':id',
        element: <Redirect to="/projects/:id" />
      },
      {
        path: ':id/edit',
        element: <Redirect to="/projects/:id/edit" />
      },
      {
        path: ':id/stats',
        element: <Redirect to="/projects/:id/stats" />
      },
      {
        path: ':id/invite-user',
        element: <Redirect to="/projects/:id/invite-user" />
      }
    ]
  }
]
